module.exports = __webpack_public_path__ + "static/media/1436.6988fb62.pdf";